import { useEffect, useState } from "react";

const RegistrationSuccessOverlay = ({ points = 0, onContinue }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center px-4 transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
      style={{ background: "rgba(5, 8, 28, 0.88)", backdropFilter: "blur(6px)" }}
    >
      <div
        className={`relative w-full max-w-sm transition-all duration-300 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
        }`}
        style={{
          background: "linear-gradient(160deg, #0d1640 0%, #1a1060 60%, #0d1640 100%)",
          border: "1px solid rgba(201, 162, 74, 0.5)",
          borderRadius: "20px",
          boxShadow: "0 0 40px rgba(201, 162, 74, 0.15), 0 20px 60px rgba(0,0,0,0.6)",
        }}
      >
        <div className="px-8 pb-8 pt-10 text-center">
          {/* Headline */}
          <p className="text-3xl font-bold text-white">🎉 Rank Saved!</p>

          {/* Points */}
          {points > 0 && (
            <p
              className="mt-4 text-2xl font-extrabold"
              style={{
                background: "linear-gradient(180deg, #FFD700, #C9A24A)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              +{points} points earned
            </p>
          )}

          {/* Divider */}
          <div
            className="mx-auto my-6 h-px w-3/4"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(201,162,74,0.3), transparent)",
            }}
          />

          {/* Feature lines */}
          <div className="space-y-3 text-sm">
            <p className="font-semibold text-white">🏆 You're now on the leaderboard</p>
            <p className="font-semibold text-white">🔥 Keep climbing</p>
          </div>

          {/* CTA */}
          <button
            type="button"
            onClick={onContinue}
            className="mt-8 w-full rounded-full py-3 text-sm font-bold tracking-wide transition active:scale-95"
            style={{
              background: "linear-gradient(180deg, #FFD700, #C9A24A)",
              color: "#1a0e00",
              boxShadow: "0 4px 20px rgba(255, 215, 0, 0.3)",
            }}
          >
            Play Another Quiz →
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccessOverlay;
